import type { PublicListingState } from './types'
import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@redux'

import {
  getPublicListing,
  asyncActions,
  getDraftedListing,
  getReviewListing,
} from './async-actions'
import { NAME } from './constant'

export const initialState: PublicListingState = {
  isContactModalOpen: false,
  error: null,
  status: 'initial',
  data: {
    id: '-',
    propertyId: '',
    agentId: '',
    information: {},
    leasingInformation: {
      leaseTerms: { leaseType: 'Month-to-month' },
      pricingDetails: { monthlyRent: 0, securityDeposit: 0 },
      dateAvailable: '',
    },
    status: 'drafted',
    screeningRequest: {},
    amenities: [],
    propertyDetails: { bathrooms: 0, bedrooms: 0 },
    customAmenities: [],
    source: '',
    partnerName: '',
    createdAt: '',
    updatedAt: '',
  },
}

export const slice = createSlice(NAME, {
  name: NAME,
  initialState,
  reducers: {
    isContactModalOpen(state, action: PayloadAction<boolean>) {
      state.isContactModalOpen = action.payload
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<PublicListingState>): void => {
    builder.addCase(getPublicListing.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(getPublicListing.fulfilled, (state, action) => {
      state.status = 'fulfilled'
      // TODO: TECH-28139 - fix/adjust `nearbyPlaces` for a new api response
      // const { nearbyPlaces } = action.payload
      // if (nearbyPlaces) {
      //   nearbyPlaces.forEach((place, idx) => {
      //     nearbyPlaces[idx].index = idx
      //   })
      // }
      state.data = action.payload
    })
    builder.addCase(getPublicListing.rejected, (state, action) => {
      state.status = 'rejected'
      state.error = action.payload as RequestError
    })

    builder.addCase(getDraftedListing.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(getDraftedListing.fulfilled, (state, action) => {
      state.status = 'fulfilled'
      // TODO: TECH-28139 - fix/adjust `nearbyPlaces` for a new api response
      // const { nearbyPlaces } = action.payload
      // if (nearbyPlaces) {
      //   nearbyPlaces.forEach((place, idx) => {
      //     nearbyPlaces[idx].index = idx
      //   })
      // }
      state.data = action.payload
    })
    builder.addCase(getDraftedListing.rejected, (state, action) => {
      state.status = 'rejected'
      state.error = action.payload as RequestError
    })

    builder.addCase(getReviewListing.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(getReviewListing.fulfilled, (state, action) => {
      state.status = 'fulfilled'
      // TODO: TECH-28139 - fix/adjust `nearbyPlaces` for a new api response
      // const { nearbyPlaces } = action.payload
      // if (nearbyPlaces) {
      //   nearbyPlaces.forEach((place, idx) => {
      //     nearbyPlaces[idx].index = idx
      //   })
      // }
      state.data = action.payload
    })
    builder.addCase(getReviewListing.rejected, (state, action) => {
      state.status = 'rejected'
      state.error = action.payload as RequestError
    })
  },
})

export const reducer = slice.reducer
export * from './selectors'

export const actions = {
  ...slice.actions,
  ...asyncActions,
}

export default { [NAME]: slice.reducer }
